import api from '@/plugins/axios'

export const getAll = async () => {
  const response = await api.get('/mesa')
  return response.data
}

export const getById = async (id) => {
  const response = await api.get(`/mesa/${id}`)
  return response.data
}

export const create = async (data) => {
  const response = await api.post('/mesa', data)
  return response.data
}

export const update = async (id, data) => {
  const response = await api.put(`/mesa/${id}`, data)
  return response.data
}

export const remove = async (id) => {
  await api.delete(`/mesa/${id}`)
}
